const emptyState = {
  feedback: false
};

export const moduleReducer = (state = emptyState, { type, payload }) => {
  switch (type) {
    case 'ACTIVATE':
      return {
        ...state,
        feedback: payload.feedback
      };

    default:
      return state;
  }
};
